import {
  Confident,
  CreatingPlan,
  Email,
  Name,
  Newsletter,
  PlanChart,
  Prediction,
} from "../../finalQuestions";
import {
  PeopleChosen,
  Initiate,
  MainGoal,
  ChooseBodyType,
  CompositionWantToHave,
  ChooseTargetZones,
  ChooseFocus,
  WeKnow,
  Age,
  EnergyLevels,
  EventDate,
  FutureEvent,
  Height,
  Report,
  WaterIntake,
  Weight,
  WeightGoal,
  WalkingJourney,
  Gender,
  LastHappyWeight,
  WhatDoYouWantToAchive,
  YouAreAmazing,
  SedentaryLifestyle,
  ActivityLevel,
  BenifitsOfWalking,
  WalkingSpendTime,
  HowOftenWalks,
  WorkLifeLookLike,
  MythOfSteps,
  Smartwatch,
  SmartwatchWear,
  StridersFoward,
  Scale,
  KindScale,
  AchiveYourGoal,
  PlanIsNowTailored,
  AverageNight,
  GoodNightSleep,
  SleepIsKey,
  HoldingsBack,
  HoldingsBack2,
  ChangeHabbits,
  GreatChoices,
  WalkingReduce,
  SetbacksBefore,
  GiveUpOnExercise,
  GraphStepper,
} from "../questions";

export const groupTitles = [
  "Goals",
  "Body profile",
  "Activity",
  "Lifestyle",
  "Personal data",
  "Motivation",
  "Almost done",
];

export const Steps = [
  {
    groupIndex: 0,
    component: Initiate,
    screenId: "Start_age_full", // ?
    screenTitle: "Personal walking plan tailored to your age ",
  },
  // {
  //   groupIndex: 0,
  //   component: Gender,
  //   screenId: "Gender",  // ?
  //   screenTitle: "What is your gender?"
  // },
  {
    groupIndex: 0,
    component: PeopleChosen,
    screenId: "Social_proof", // ?
    screenTitle: "4,280,000+ users have chosen us",
  },
  {
    groupIndex: 0,
    component: WhatDoYouWantToAchive,
    headerTitle: true,
    screenId: "Goals", // ?
    mappingKey: "qqWalkingGoal",
    screenTitle: "What do you hope to achieve?",
  },
  {
    groupIndex: 0,
    component: WalkingJourney,
    screenId: "Feedback_target", // ?
    screenTitle: "Welcome to your walking journey!",
  },
  {
    groupIndex: 0,
    component: MainGoal,
    headerTitle: true,
    screenId: "Main_goal",
    screenTitle: "What is your weight goal?",
  },
  {
    groupIndex: 0,
    component: WeKnow,
    screenId: "Feedback_weight_goal",
    screenTitle: "We know how to make it happen!",
  },
  // {
  //   groupIndex: 0,
  //   component: BodyType,
  //   screenId: "Body_type",
  //   screenTitle: "Choose your current body type"
  // },
  // {
  //   groupIndex: 0,
  //   component: BodyComposition,
  //   screenId: "Body_composition",
  //   screenTitle: "What body composition do you want to have?"
  // },
  {
    groupIndex: 1,
    component: ChooseBodyType,
    headerTitle: true,
    screenId: "Target_body",
    screenTitle: "What body composition do you want to have?",
  },
  {
    groupIndex: 1,
    component: CompositionWantToHave,
    headerTitle: true,
    screenId: "Target_body",
    screenTitle: "What body composition do you want to have?",
  },
  {
    groupIndex: 1,
    component: LastHappyWeight,
    headerTitle: true,
    screenId: "LastHappyWeight",
    screenTitle: "When were you last happy with your weight?",
  },
  {
    groupIndex: 1,
    component: GraphStepper,
    headerTitle: true,
    screenId: "GraphStepper",
    screenTitle: "Your goal is achievable!",
  },
  // aninamtion graph
  {
    groupIndex: 1,
    component: ChooseTargetZones,
    headerTitle: true,
    screenId: "Target_zones",
    screenTitle: "Choose your target zones",
  },
  {
    groupIndex: 1,
    component: YouAreAmazing,
    screenId: "You_Are_Amazing", // ?
    screenTitle: "You're amazing! ",
  },
  {
    groupIndex: 2,
    component: SedentaryLifestyle,
    headerTitle: true,
    screenId: "SedentaryLifestyle",
    screenTitle: "Do you have a sedentary lifestyle?",
  },
  {
    groupIndex: 2,
    component: ActivityLevel,
    headerTitle: true,
    screenId: "ActivityLevel",
    screenTitle: "What is your activity level?",
    mappingKey: "qqActivityLevel",
  },

  {
    groupIndex: 2,
    component: BenifitsOfWalking,
    screenId: "BenifitsOfWalking", // ?
    screenTitle: "Discover the benefits of walking",
  },
  {
    groupIndex: 2,
    component: ChooseFocus,
    headerTitle: true,
    screenId: "Tags",
    screenTitle: "Choose your focus",
  },
  {
    groupIndex: 2,
    component: WalkingSpendTime,
    headerTitle: true,
    screenId: "WalkingSpendTime",
    screenTitle: "How much time do you spend walking on a typical day?",
  },
  {
    groupIndex: 2,
    component: HowOftenWalks,
    headerTitle: true,
    screenId: "HowOftenWalks",
    mappingKey: "qqWalksFrequency",
    screenTitle: "How often do you go for walks?",
  },
  {
    groupIndex: 2,
    component: WorkLifeLookLike,
    headerTitle: true,
    screenId: "WorkLifeLookLike",
    screenTitle: "How does your work life look like?",
  },
  {
    groupIndex: 2,
    component: MythOfSteps,
    screenId: "MythOfSteps", // ?
    screenTitle: "The myth of 10,000 steps ",
  },
  {
    groupIndex: 2,
    component: Smartwatch,
    headerTitle: true,
    screenId: "Smartwatch",
    screenTitle: "Do you wear a smartwatch or fitness tracker?",
  },
  {
    groupIndex: 2,
    component: SmartwatchWear,
    headerTitle: true,
    screenId: "SmartwatchWear",
    screenTitle: "What kind of smartwatch or fitness tracker do you wear?",
  },
  {
    groupIndex: 2,
    component: StridersFoward,
    screenId: "StridersFoward", // ?
    screenTitle: "You're making strides towards your goal!",
  },
  {
    groupIndex: 2,
    component: Scale,
    headerTitle: true,
    screenId: "Scale",
    screenTitle: "Do you own a scale?",
  },
  {
    groupIndex: 2,
    component: KindScale,
    headerTitle: true,
    screenId: "KindScale",
    screenTitle: "What kind of smart scale do you have?",
  },
  {
    groupIndex: 3,
    component: AchiveYourGoal,
    headerTitle: true,
    screenId: "AchiveYourGoal",
    screenTitle: "What pace would you like to achieve your goal at?",
  },
  {
    groupIndex: 3,
    component: PlanIsNowTailored,
    screenId: "PlanIsNowTailored",
    screenTitle: "Great! Your plan is now tailored to your level",
  },
  {
    groupIndex: 3,
    component: AverageNight,
    headerTitle: true,
    screenId: "AverageNight",
    screenTitle: "Truthfully, what is an average night like for you?",
  },
  {
    groupIndex: 3,
    component: GoodNightSleep,
    headerTitle: true,
    screenId: "GoodNightSleep",
    screenTitle: "Struggling to get a good night's sleep?",
  },
  {
    groupIndex: 3,
    component: SleepIsKey,
    screenId: "SleepIsKey",
    screenTitle: "Sleep is key for weight loss",
  },
  {
    groupIndex: 3,
    component: EnergyLevels,
    headerTitle: true,
    screenId: "EnergyLevels",
    screenTitle: "What about your energy levels?",
  },
  {
    groupIndex: 3,
    component: WaterIntake,
    headerTitle: true,
    screenId: "WaterIntake",
    screenTitle: "What is your daily water intake?",
  },
  {
    groupIndex: 3,
    component: HoldingsBack,
    headerTitle: true,
    screenId: "HoldingsBack",
    screenTitle: "Any of these holding you back?",
  },
  {
    groupIndex: 3,
    component: HoldingsBack2,
    headerTitle: true,
    screenId: "HoldingsBack2",
    screenTitle: "Any of these holding you back?",
  },
  {
    groupIndex: 3,
    component: ChangeHabbits,
    screenId: "ChangeHabbits",
    screenTitle: "You can always change your habits for the better ",
  },
  {
    groupIndex: 4,
    component: Height,
    headerTitle: true,
    screenId: "Height",
    mappingKey: "qqHeightCm",
    screenTitle: "How tall are you",
  },
  {
    groupIndex: 4,
    component: Weight,
    headerTitle: true,
    screenId: "Weight",
    mappingKey: "qqWeightKg",
    screenTitle: "What's your current weight?",
  },
  {
    groupIndex: 4,
    component: WeightGoal,
    headerTitle: true,
    mappingKey: "qqGoalWeightKg",
    screenId: "Target_weight",
    screenTitle: "Great! What weight are you aiming for?",
  },
  {
    groupIndex: 4,
    component: Age,
    headerTitle: true,
    mappingKey: "qqAge",
    screenId: "age",
    screenTitle: "What is your age?",
  },
  {
    groupIndex: 4,
    component: GreatChoices,
    screenId: "GreatChoices",
    screenTitle: "Great choices! We are almost done! ",
  },
  {
    groupIndex: 4,
    component: Report,
    headerTitle: true,
    screenId: "Fitlevel_feedback",
    screenTitle: "Your current fitness level overview",
  },
  {
    groupIndex: 4,
    component: WalkingReduce,
    screenId: "WalkingReduce",
    screenTitle: "Great choices! We are almost done! ",
  },
  {
    groupIndex: 5,
    component: SetbacksBefore,
    headerTitle: true,
    screenId: "SetbacksBefore",
    screenTitle: "Have you struggled with any of these setbacks before?",
  },
  {
    groupIndex: 5,
    component: GiveUpOnExercise,
    screenId: "GiveUpOnExercise",
    screenTitle: "Why do people give up on exercise? ",
  },
  {
    groupIndex: 5,
    component: FutureEvent,
    headerTitle: true,
    mappingKey: "qqOccasion",
    screenId: "ocassion",
    screenTitle: "Do you have an important occasion coming up?",
  },
  {
    groupIndex: 5,
    component: EventDate,
    headerTitle: true,
    mappingKey: "qqOccasionDate",
    screenId: "Ocasion_date",
    screenTitle: "When is this occasion?",
  },
  {
    groupIndex: 6,
    component: Prediction,
    headerTitle: true,
    screenId: "Prediction",
    screenTitle: "The only program you'll ever need to get your dream body",
  },
  {
    groupIndex: 6,
    component: Confident,
    headerTitle: true,
    screenId: "Confident",
    screenTitle: "How confident are you in reaching",
  },
  {
    groupIndex: 6,
    component: CreatingPlan,
    headerTitle: true,
    screenId: "CreatingPlan",
    screenTitle: "Creating your personalized plan",
  },
  {
    groupIndex: 6,
    component: Email,
    headerTitle: true,
    screenId: "Email",
    screenTitle: "Enter your email to receive Your Custom Program",
  },
  {
    groupIndex: 6,
    component: Newsletter,
    headerTitle: true,
    screenId: "Newsletter",
    screenTitle:
      "Do you want to receive emails with Weight Loss tips and our product updates?",
  },
  {
    groupIndex: 6,
    component: Name,
    headerTitle: true,
    screenId: "Name",
    screenTitle: "What’s your name?",
  },
    {
    groupIndex: 6,
    component: PlanChart,
    headerTitle: true,
    screenId: "PlanChart",
    screenTitle: "PlanChart",
  },
];
